/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  GroupInterface,
  ProviderClassGroupsResponseInterface,
  SaveProviderClassGroupsRequestInterface,
} from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GroupApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Groups');
  }

  create(group: GroupInterface): Observable<GroupInterface> {
    const path = '';
    const params = undefined;
    return this.post<GroupInterface>(path, params, group);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<boolean>(path).pipe(map(() => true));
  }

  deleteSmsc(id: number): Observable<boolean> {
    const path = `${id}/smsc`;
    return this.delete<boolean>(path);
  }

  patchAttributes(id: number, updates: Partial<GroupInterface>): Observable<GroupInterface> {
    const path = `${id}`;
    return this.patch(path, undefined, updates);
  }

  getClassGroupsForProvider(providerId: number | string): Observable<ProviderClassGroupsResponseInterface> {
    const path = `providers/${providerId}`;
    return this.get<ProviderClassGroupsResponseInterface>(path);
  }

  saveClassGroupsForProvider(
    providerId: number | string,
    body: SaveProviderClassGroupsRequestInterface
  ): Observable<unknown> {
    const path = `providers/${providerId}`;
    return this.post(path, undefined, body);
  }
}
